import {
  Environment
} from '@vodacom/web-env';

import {
  AppState,
  getAuthToken,
  onVouchersNoAuth
} from 'helpers';

import {
  CacheStrategy
} from '../../../../constants';

export class CheckoutProvider {

  static BASE_URL = Environment.current.checkoutHost + Environment.current.checkoutBase
  static STATE = AppState.with('CheckoutProvider');

  static getDefaultHeaders() {
    return (
      {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + getAuthToken()
      }
    );
  }

  static async checkoutVoucherOrder(
    productId,
    paymentType,
    paymentTypeValue,
    paymentTerm = undefined,
    paymentTermValue = undefined,
    offerId = undefined,
    eligibilityRequestId = undefined
  ) {

    const characteristicArray = [
      {
        'name': paymentType,
        'value': paymentTypeValue
      }
    ];

    if (paymentTerm !== 'none') {

      characteristicArray.push({
        'name': paymentTerm,
        'value': paymentTermValue
      });
    }

    const bodyParams = {
      'product': {
        'quantity': 1,
        'id': productId,
        'paymentType': paymentType,
        'characteristic': characteristicArray
      }
    };

    if (offerId && eligibilityRequestId) {
      bodyParams['offerId'] = offerId;
      bodyParams['eligibilityRequestId'] = eligibilityRequestId;
    }

    return CheckoutProvider.STATE.makeServiceCall(
      `${CheckoutProvider.BASE_URL}checkout`,
      {
        method: 'POST',
        bodyParams: bodyParams,
        headers: {
          ...CheckoutProvider.getDefaultHeaders()
        },
        cacheStrategy: CacheStrategy.None
      }
    )
    .then((res) => {

      if (!res?.ok) {

        return {
          ok: false,
          error: new Error('request failed'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }

      return res;
    })
    .catch((error) => {

      onVouchersNoAuth(error);

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: error?.response?.status,
        stamp: new Date()
      };
    });
  }
}